import useSWR from 'swr'

import { MutationOptions, useCallMutation } from '@/common/api/client'
import {
  CitationApiPath,
  GetCitationHistoryDetailResponse,
  GetCitationHistoryDetailVars,
  RunCitationAnalysisResponse,
  RunCitationAnalysisVars
} from '@/common/api/params/citation'

// 分析結果詳細（SWR）。
// options.refreshInterval > 0 で自動更新（分析中のポーリング用）。
// 関数形式（最新データを受け取る）も可能で、status が analyzing の間だけポーリングする用途に使う。
export const useCitationHistoryDetailApi = (
  vars: GetCitationHistoryDetailVars | undefined,
  options?: {
    refreshInterval?: number | ((latest: GetCitationHistoryDetailResponse | undefined) => number)
  }
) => {
  return useSWR<
    GetCitationHistoryDetailResponse,
    Response,
    [string, GetCitationHistoryDetailVars] | undefined
  >(vars ? [CitationApiPath.GET_CITATION_HISTORY_DETAIL, vars] : undefined, {
    refreshInterval: options?.refreshInterval ?? 0
  })
}

// バックグラウンド実行を起動する（レコードを作成し、即座に id/status を返す）
export const useRunCitationAnalysisApi = (
  options?: MutationOptions<RunCitationAnalysisResponse>
) => {
  return useCallMutation<RunCitationAnalysisResponse, RunCitationAnalysisVars>(
    CitationApiPath.RUN_CITATION_ANALYSIS,
    options
  )
}
